<template>
  <div :class="['text_label_value text_size_14', {'align_center': alignCenter}]" :style="`min-height:${height}px`">
    <span class="label" :style="`width: ${labelWidth}px;height:${height}px;line-height:${height}px`">
      {{ label }}
    </span>
    <span class="value" :style="`line-height:${height}px;width:${valueWidth}px;`">
      <slot></slot>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 32
    },
    labelWidth: {
      type: Number,
      default: 130
    },
    valueWidth: {
      type: Number,
      default: 300
    },
    alignCenter: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
  .text_label_value {
    display: flex;
    width: 100%;
    min-height: 32px;
    margin-bottom: 22px;
    .label {
      width: 130px;
      height: 32px;
      line-height: 32px;
      color: $color-text-primary;
    }
    .value {
      width: 300px;
      line-height: 32px;
      color: $color-text-primary;
      &.textarea {
        line-height: 28px;
      }
      .value_item {
        width: 244px;
      }
      .value_item+.value_item {
        margin-top: 22px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/text/text-label-value.vue